import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { State } from '../../store/main';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RouteAuthGuard  {
  public constructor(private router: Router, private store: Store<State>) {}

  public canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<UrlTree | boolean> {
    return this.store.pipe(
      select('auth', 'isAuthenticated'),
      map(isAuth => {
        return isAuth ? isAuth : this.router.parseUrl(`/login`);
      }),
    );
  }
}
